/**
 * Check if number is float
 * 
 * @param {any} n - Number to check.
 * @return {boolean}
 */
export const isFloat = n => Number(n) === n && n % 1 !== 0;